import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getCategories } from "../../inventory-items/inventory-item-create/item-create.component.service";
import {
  getFileUploadsApi,
  deleteFileUploadApi,
  uploadFileApi,
} from "./file-upload.component.service";
import {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters as rawFilters,
} from "./model/file-upload-list.constants";
import FileUploadTemplateComponent from "./file-upload-template.component";
import { getFilterData } from "@utils/common";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ITEM_ALERTS: { DELETE_ALERT },
} = MESSAGES;

const FileUploadComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const filters = getFilterData(filterList, menuUrl, "filter");
  const [filterState, setFilterState] = useState(filters);
  const [uploadFormData, setUploadFormData] = useState([
    { name: "category_id", value: "" },
    { name: "file", value: null },
  ]);
  const [loading, setLoading] = useState(false);

  const getFileUploadData = async (payload) => {
    setLoading(true);
    const response = await getFileUploadsApi(payload);
    setLoading(false);

    if (response.status) {
      // Add category name to each row
      const enrichedData = response.data.map(row => {
        const category = categories.find(cat => cat.value === row.category_id);
        return {
          ...row,
          category_name: category ? category.name : 'N/A'
        };
      });
      setTableData(enrichedData);
      setTotalCount(response.totalCount);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const deleteRecords = async (ids) => {
    const response = await deleteFileUploadApi(ids);
    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: DELETE_ALERT }));
      getFileUploadData({
        sortBy: "desc",
        orderBy: "created_at",
        skip: 0,
        limit: 10,
      });
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const submitFilter = (updatedFilter) => {
    let filterString = "";
    updatedFilter.forEach((filter) => {
      if (filter.value) {
        filterString += `&${filter.name}=${filter.value}`;
      }
    });

    getFileUploadData({
      sortBy: "desc",
      orderBy: "created_at",
      skip: 0,
      limit: 10,
      filters: filterString,
    });
  };
    
  const onLoad = async () => {
    const response = await getCategories();
    if (response.status) {
      const formattedCategories = response.data?.map((cat) => ({
        name: cat.name,
        value: cat.id,
      }));
      setCategories(formattedCategories);
      console.log({formattedCategories});
      const categoryFilters = rawFilters({
        categories: formattedCategories || [],
      });
      setFilterState(categoryFilters);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (categories.length > 0) {
        setLoading(true);
        const response = await getFileUploadsApi({
          sortBy: "desc",
          orderBy: "created_at",
          skip: 0,
          limit: 10,
        });
        setLoading(false);

        if (response.status) {
          const enrichedData = response.data.map(row => {
            const category = categories.find(cat => cat.value === row.category_id);
            return {
              ...row,
              category_name: category ? category.name : ''
            };
          });
          setTableData(enrichedData);
          setTotalCount(response.totalCount);
        } else {
          dispatch(setAlertMessage({ type: ERROR, message: response.message }));
        }
      }
    };
    
    fetchData();
  }, [categories, dispatch]);


  const templateModal = {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters:filterState,
    openUploadModal,
    categories,
    uploadFormData,
    loading,
  };

  const templateEvents = {
    getFileUploadData,
    deleteRecords,
    submitFilter,
  };

  return menuAccess ? (
    <FileUploadTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default FileUploadComponent;
